import './header.css';

import * as React from 'react';

import { Navbar, Nav, NavbarToggler, NavbarBrand, Collapse } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { NavLink as Link } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar';

import { Home, Brand } from './header-components';
import { AdminMenu, EntitiesMenu, AccountMenu } from './menus';
import { getSession } from 'app/shared/reducers/authentication';
import { connect } from 'react-redux';

export interface IHeaderProps extends StateProps, DispatchProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isSwaggerEnabled: boolean;
}

export interface IHeaderState {
  menuOpen: boolean;
  accountName: string;
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {
  previouseIsAuthenticated = false;

  state: IHeaderState = {
    menuOpen: false,
    accountName: 'Account'
  };

  componentDidUpdate() {
    const { isAuthenticated } = this.props;

    const { account } = this.props;
    if (isAuthenticated !== this.previouseIsAuthenticated) {
      if (isAuthenticated) {
        this.setState({
          accountName: account.firstName
        });
      } else {
        this.setState({
          accountName: 'Account'
        });
      }
      this.previouseIsAuthenticated = isAuthenticated;
    }
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  render() {
    const { isAuthenticated, isAdmin, isSwaggerEnabled } = this.props;
    return (
      <header id="app-header">
        <LoadingBar className="loading-bar" />
        <Navbar dark expand="md" fixed="top" className="app-navbar">
          <div className="navbar-left">
            <NavbarToggler aria-label="Menu" onClick={this.toggleMenu} />
            <Brand />
            <div id="header-shelf-count" />
          </div>
          <Collapse isOpen={this.state.menuOpen} navbar>
            <Nav className="navbar-right" navbar>
              <Home />
              {isAuthenticated && isAdmin && <EntitiesMenu />}
              {isAuthenticated && isAdmin && <AdminMenu showSwagger={isSwaggerEnabled} />}
              <AccountMenu isAuthenticated={isAuthenticated} accountName={this.state.accountName} />
            </Nav>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}

const mapStateToProps = storeState => ({
  account: storeState.authentication.account
});

const mapDispatchToProps = { getSession };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Header);
